<template>
  <nav
    class="navbar navbar-expand-lg sticky-top header-auto"
    :class="{ 'header-hidden': isHidden }"
    style="background-color: #004081 !important"
  >
    <div class="container-fluid">
      <section class="d-flex align-items-center gap-3">
        <img src="../assets/euroc_v1_white_sm.png" alt="EuRoC" height="60" />

        <router-link
          v-if="isAuthenticated"
          class="navbar-brand my-text-color ps-1"
          to="/main"
          @click="onNav"
          >EuRoC Scoring</router-link
        >
        <router-link
          v-else
          class="navbar-brand my-text-color ps-1"
          to="/home"
          @click="onNav"
          >EuRoC Scoring</router-link
        >

        <span v-if="isAuthenticated" class="navbar-brand my-text-color">{{
          _edition
        }}</span>
      </section>

      <!-- Hamburger: we toggle collapse programmatically -->
      <button
        id="navToggler"
        class="navbar-toggler"
        type="button"
        :aria-expanded="isCollapsedOpen ? 'true' : 'false'"
        aria-label="Toggle navigation"
        @click="onTogglerClick"
      >
        <!-- show bars when closed -->
        <span class="my-text-color" v-show="!isCollapsedOpen">
          <i class="fa-solid fa-bars"></i>
        </span>
        <!-- show X when open -->
        <span class="my-text-color" v-show="isCollapsedOpen">
          <i class="fa-solid fa-xmark"></i>
        </span>
      </button>

      <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
        <ul class="navbar-nav">
          <!-- Admin only -->
          <li class="nav-item" v-if="isAuthenticated && levelID === 'ADM'">
            <router-link
              class="nav-link my-text-color"
              to="/users"
              @click="onNav"
              >Users</router-link
            >
          </li>
          <li class="nav-item" v-if="isAuthenticated && levelID === 'ADM'">
            <router-link
              class="nav-link my-text-color"
              to="/categories"
              @click="onNav"
              >Categories</router-link
            >
          </li>
          <li class="nav-item" v-if="isAuthenticated && levelID === 'ADM'">
            <router-link
              class="nav-link my-text-color"
              to="/projects"
              @click="onNav"
              >Projects</router-link
            >
          </li>
          <li class="nav-item" v-if="isAuthenticated && levelID === 'ADM'">
            <router-link
              class="nav-link my-text-color"
              to="/teams"
              @click="onNav"
              >Teams</router-link
            >
          </li>
          <li class="nav-item" v-if="isAuthenticated && levelID === 'ADM'">
            <router-link class="nav-link my-text-color" to="/teb" @click="onNav"
              >TEB</router-link
            >
          </li>

          <!-- FRR (roles) -->
          <li
            class="nav-item"
            v-if="
              isAuthenticated &&
              ['TEB', 'TBL', 'OPL', 'ADM', 'OPS', 'PTS'].includes(levelID)
            "
          >
            <router-link
              class="nav-link my-text-color"
              to="/frr_projects"
              @click="onNav"
              >FRR</router-link
            >
          </li>

          <!-- Scoring dropdown (Vue-controlled) -->
          <li
            class="nav-item dropdown"
            v-if="
              isAuthenticated &&
              ['ADM', 'TEB', 'TBL', 'OPL', 'PTS', 'OPS'].includes(levelID)
            "
          >
            <a
              class="nav-link dropdown-toggle my-text-color"
              href="#"
              role="button"
              aria-expanded="false"
              @click="toggle('scoring')"
              >Scoring</a
            >

            <ul
              class="dropdown-menu dropdown-menu-end"
              :class="{ show: openMenu === 'scoring' }"
            >
              <li v-if="isAuthenticated && levelID === 'ADM'">
                <router-link
                  class="dropdown-item"
                  to="/gradingparams"
                  @click="onNav"
                  >Grading (settings)</router-link
                >
              </li>
              <li v-if="isAuthenticated && levelID === 'ADM'">
                <hr class="dropdown-divider" />
              </li>

              <li
                v-if="
                  isAuthenticated &&
                  ['ADM', 'OPL', 'PTS', 'TEB', 'TBL', 'OPS'].includes(levelID)
                "
              >
                <router-link
                  class="dropdown-item"
                  to="/scoring_reports"
                  @click="onNav"
                  >Scoring Reports</router-link
                >
              </li>
              <li
                v-if="
                  isAuthenticated && ['ADM', 'OPL', 'PTS'].includes(levelID)
                "
              >
                <hr class="dropdown-divider" />
              </li>

              <li
                v-if="
                  isAuthenticated &&
                  ['ADM', 'TEB', 'TBL', 'OPL', 'PTS'].includes(levelID)
                "
              >
                <router-link
                  class="dropdown-item"
                  to="/tr_projects"
                  @click="onNav"
                  >Technical Report</router-link
                >
              </li>
              <li
                v-if="
                  isAuthenticated &&
                  ['ADM', 'TEB', 'TBL', 'OPL', 'PTS'].includes(levelID)
                "
              >
                <router-link
                  class="dropdown-item"
                  to="/design_projects"
                  @click="onNav"
                  >Vehicle Design</router-link
                >
              </li>
              <li
                v-if="
                  isAuthenticated && ['ADM', 'OPL', 'PTS'].includes(levelID)
                "
              >
                <router-link
                  class="dropdown-item"
                  to="/effort_projects"
                  @click="onNav"
                  >Team Effort</router-link
                >
              </li>
              <li v-if="isAuthenticated && ['ADM', 'OPL'].includes(levelID)">
                <router-link
                  class="dropdown-item"
                  to="/flight_projects"
                  @click="onNav"
                  >Flight Performance</router-link
                >
              </li>
              <li
                v-if="
                  isAuthenticated &&
                  ['ADM', 'TEB', 'TBL', 'OPL', 'PTS'].includes(levelID)
                "
              >
                <router-link
                  class="dropdown-item"
                  to="/pl_projects"
                  @click="onNav"
                  >Payload</router-link
                >
              </li>
              <li v-if="isAuthenticated && levelID === 'ADM'">
                <router-link
                  class="dropdown-item"
                  to="/frr_parameters"
                  @click="onNav"
                  >FRR (settings)</router-link
                >
              </li>
            </ul>
          </li>

          <!-- Username -->
          <li class="nav-item" v-if="isAuthenticated">
            <span class="nav-link my-text-color">{{ name }}</span>
          </li>

          <!-- Avatar (only if has image) -->
          <li v-if="isAuthenticated && img" class="d-flex align-items-center">
            <img
              :src="img"
              alt="avatar"
              width="45"
              height="45"
              class="rounded-circle me-2"
              style="
                background-color: white;
                border-radius: 2px;
                border: 1px solid white;
              "
            />
          </li>

          <!-- Settings dropdown (Vue-controlled) -->
          <li class="nav-item dropdown" v-if="isAuthenticated">
            <a
              class="nav-link dropdown-toggle my-text-color no-caret"
              href="#"
              role="button"
              aria-expanded="false"
              @click.prevent="toggle('settings')"
            >
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </a>
            <ul
              class="dropdown-menu dropdown-menu-end mb-3"
              :class="{ show: openMenu === 'settings' }"
              style="max-width: 200px"
            >
              <li>
                <router-link
                  class="dropdown-item"
                  to="/"
                  @click.stop.prevent="handleSignOut"
                  >Sign out</router-link
                >
              </li>
              <li><hr class="dropdown-divider" /></li>
              <li>
                <router-link class="dropdown-item" to="/useraccount"
                  >Profile</router-link
                >
              </li>
            </ul>
          </li>

          <!-- Not authenticated -->
          <li class="nav-item ms-auto" v-if="!isAuthenticated">
            <router-link
              class="nav-link my-text-color me-2"
              id="signin"
              to="/login"
              @click="onNav"
              style="
                border: 2px solid white;
                border-radius: 15px;
                padding: 7px 12px;
              "
              >Sign in</router-link
            >
          </li>
          <li class="nav-item ms-auto" v-if="!isAuthenticated">
            <router-link
              class="nav-link me-2"
              id="register"
              to="/register"
              @click="onNav"
              style="
                background-color: white;
                color: #004081;
                border: 2px solid white;
                border-radius: 15px;
                padding: 7px;
              "
              >Register</router-link
            >
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { Collapse } from "bootstrap";
import { notifyInfo } from "../modules/toastService";
import { mapActions, mapGetters } from "vuex";
import {
  IS_USER_AUTHENTICATED_GETTER,
  LOGOUT_ACTION,
  GET_USER_LEVEL_GETTER,
  GET_USER_NAME_GETTER,
  GET_USER_AVATAR_GETTER,
  GET_USER_ID_GETTER,
  GET_USER_TOKEN_GETTER,
  GET_EDITION_GETTER,
} from "../store/storeconstants";

export default {
  name: "Navbar",
  data() {
    return {
      openMenu: null, // 'scoring' | 'settings' | null
      isCollapsedOpen: false, // for aria-expanded on the button
      isHidden: false,
      lastY: 0,
      threshold: 50,
    };
  },
  mounted() {
    this.lastY = window.pageYOffset || 0;
    window.addEventListener("scroll", this.onScroll, { passive: true });
  },

  computed: {
    ...mapGetters("auth", {
      isAuthenticated: IS_USER_AUTHENTICATED_GETTER,
      levelID: GET_USER_LEVEL_GETTER,
      name: GET_USER_NAME_GETTER,
      img: GET_USER_AVATAR_GETTER,
      token: GET_USER_TOKEN_GETTER,
      userID: GET_USER_ID_GETTER,
      _edition: GET_EDITION_GETTER,
    }),

    ...mapGetters("ui", { _unsaved: "HAS_UNSAVED_CHANGES" }),
  },

  methods: {
    ...mapActions("auth", { _logout: LOGOUT_ACTION }),
    onScroll() {
      const y = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (y < this.threshold) {
        this.isHidden = false;
        this.lastY = y;
        return;
      }
      if (y - this.lastY >= this.threshold) {
        this.isHidden = true;
        this.lastY = y;
      } else if (this.lastY - y >= this.threshold) {
        this.isHidden = false;
        this.lastY = y;
      }
    },
    toggle(which) {
      this.openMenu = this.openMenu === which ? null : which;
    },

    async logout() {
      const ok = await this._logout();
      if (ok) {
        notifyInfo("Signed out.");
        this.$router.replace("/home");
      }
    },

    async handleSignOut() {
      this.onNav();
      if (this._unsaved) {
        return; // BLOCK sign out
      }
      await this.logout();
      this.$router.push("home");
      this.onNav();
      this.openMenu = null;
    },

    onNav() {
      // Close the mobile menu after navigation & any open dropdown
      const el = document.getElementById("navbarNav");
      if (el) {
        const inst = Collapse.getOrCreateInstance(el, { toggle: false });
        inst.hide();
      }
      this.isCollapsedOpen = false;
      this.openMenu = null;
    },

    onTogglerClick(e) {
      // Always close dropdowns first so nothing overlays the button
      this.openMenu = null;

      // Toggle the collapse explicitly (do not rely on data API)
      const el = document.getElementById("navbarNav");
      if (!el) return;

      const inst = Collapse.getOrCreateInstance(el, { toggle: false });
      if (el.classList.contains("show")) {
        inst.hide();
        this.isCollapsedOpen = false;
      } else {
        inst.show();
        this.isCollapsedOpen = true;
      }
    },
  },
};
</script>

<style>
.header-auto {
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  will-change: transform;
}
.header-hidden {
  transform: translateY(-100%);
}
*:focus {
  outline: 0 !important;
}
.my-text-color {
  color: white !important;
}

.navbar .navbar-nav .nav-link:hover {
  color: #9fc7ec !important;
}
.navbar .navbar-nav .nav-item {
  position: relative;
}

/* Keep menus above content; avoid right overflow */
.navbar {
  position: relative;
  z-index: 1051;
}
.navbar .dropdown-menu {
  overflow-wrap: anywhere;
}
.navbar .dropdown-menu-end {
  right: 0;
  left: auto;
}
.navbar .dropdown-menu {
  max-width: min(320px, calc(100vw - 1rem));
}

/* Vue-controlled dropdown visibility */
.dropdown-menu.show {
  display: block !important;
}

/* Hide caret on the ellipsis dropdown only */
.navbar .dropdown-toggle.no-caret::after {
  display: none !important;
}

/* ✅ Make sure the toggler (bars/X) always gets the click */
.navbar .navbar-toggler {
  position: relative;
  z-index: 9999;
  pointer-events: auto;
}

/* ✅ Responsive dropdown positioning:
   - On mobile (< lg) keep dropdowns static so they don't overlay the header/toggler
   - On desktop (≥ lg) make them absolute popovers */
@media (max-width: 991.98px) {
  .navbar .dropdown-menu {
    position: static !important;
    box-shadow: none;
  }
}
@media (min-width: 992px) {
  .navbar .dropdown-menu {
    position: absolute;
    z-index: 1062;
  }
}
</style>
